export default '/@lang/advisory'
